/** Cómo se pinta la ventana de 24 h en el listado.  (spec 072) */

const VENTANA_MS = 24 * 60 * 60 * 1000

export type TonoVentana = 'abierta' | 'cerrada' | 'desconocida'

export function textoVentanaLista(
    iso: string | null,
    conocida: boolean,
    ahora: number,
): { texto: string; tono: TonoVentana } {
    if (!conocida) return { texto: 'No se sabe', tono: 'desconocida' }
    if (!iso) return { texto: 'Cerrada', tono: 'cerrada' }
    const fin = new Date(iso).getTime() + VENTANA_MS
    const queda = fin - ahora
    if (!Number.isFinite(fin) || queda <= 0) return { texto: 'Cerrada', tono: 'cerrada' }
    const total = Math.floor(queda / 1000)
    const h = Math.floor(total / 3600)
    const m = Math.floor((total % 3600) / 60)
    const s = total % 60
    const mm = String(m).padStart(2, '0')
    const ss = String(s).padStart(2, '0')
    return { texto: `${h}:${mm}:${ss}`, tono: 'abierta' }
}

export type ClaveOrden = 'nombre' | 'telefono' | 'correo' | 'estado' | 'ventana' | 'testigo' | 'actividad'
export type DireccionOrden = 'asc' | 'desc'

export function direccionInicial(clave: ClaveOrden): DireccionOrden {
    if (clave === 'ventana' || clave === 'actividad') return 'desc'
    return 'asc'
}

/** Null al final, en las dos direcciones. */
export function compararOrden(a: string | null, b: string | null, dir: DireccionOrden): number {
    if (a === null && b === null) return 0
    if (a === null) return 1
    if (b === null) return -1
    const n = a.localeCompare(b, 'es', { numeric: true, sensitivity: 'base' })
    return dir === 'asc' ? n : -n
}
